import React, { useEffect, useRef, useState } from 'react'
import { Button, message } from 'antd'
import { ExportOutlined } from '@ant-design/icons'
import { PreviewFile, previewKind } from './files'

export default function OpenFileButton({ file, label = 'Открыть в новой вкладке' }: { file: PreviewFile; label?: string }) {
  const [loading, setLoading] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  const request = useRef<AbortController>()
  useEffect(() => () => request.current?.abort(), [])

  async function open() {
    const tab = window.open('about:blank', '_blank')
    if (!tab) {
      messageApi.warning('Разрешите открытие новой вкладки в браузере и попробуйте ещё раз.')
      return
    }
    tab.opener = null
    const controller = new AbortController()
    request.current = controller
    setLoading(true)
    try {
      const response = await fetch(file.url, { signal: controller.signal, credentials: 'same-origin' })
      if (!response.ok) throw new Error('File unavailable')
      const blob = await response.blob()
      if (controller.signal.aborted) { tab.close(); return }
      if (tab.closed) return
      const kind = previewKind(file)
      const safeMime = kind === 'pdf' ? 'application/pdf' : kind === 'text' ? 'text/plain' :
        /^(image\/(png|jpeg|gif|webp|bmp|avif|x-icon)|audio\/[a-z0-9.+-]+|video\/[a-z0-9.+-]+)$/i.test(blob.type) ? blob.type : 'application/octet-stream'
      const url = URL.createObjectURL(new Blob([blob], { type: safeMime }))
      tab.location.replace(url)
      setTimeout(() => URL.revokeObjectURL(url), 60000)
    } catch {
      tab.close()
      if (!controller.signal.aborted) messageApi.error('Не удалось открыть оригинал. Попробуйте ещё раз.')
    } finally {
      if (!controller.signal.aborted) setLoading(false)
    }
  }

  return <>{contextHolder}<Button size="small" type="text" icon={<ExportOutlined />} loading={loading} onClick={open}>{label}</Button></>
}
